export default __webpack_public_path__ + "static/media/icon-download.45511fd0.svg";